import { Heading } from 'Components/_theme'

import { DashboardDeviceSlide } from './DashboardDeviceSlide'
import { DEVICE_SLIDE } from './DashboardDeviceSlide.constants'

export const DashboardDeviceSlidePresentation = () => {
  const renderDeviceSlides = () =>
    DEVICE_SLIDE.map(slide => (
      <DashboardDeviceSlide
        id={slide.id}
        imageURL={slide.imageURL}
        imei={slide.imei}
        name={slide.name}
        startAt={slide.startAt}
        status={slide.status}
        type={slide.type}
      />
    ))

  return (
    <div>
      <Heading className="pt-4" size={4}>
        Dashboard Device Slide:
      </Heading>

      {/* *** Dashboard Device slide  *** */}

      <div className="d-flex pt-4">{renderDeviceSlides()}</div>
    </div>
  )
}
